(function attachSearchspringTracking(window) {
  const CART_ENDPOINT = '/cart.js';
  const DEBOUNCE_MS = 300;

  let pendingSync = null;
  let debounceTimer = null;

  function centsToDecimalString(cents) {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return '0.00';
    return (amount / 100).toFixed(2);
  }

  function toCartItem(item) {
    const childSku = item?.sku ? String(item.sku).trim() : '';
    if (!childSku) return null;

    return {
      childSku,
      qty: Number(item.quantity) || 0,
      price: centsToDecimalString(item.final_price ?? item.price ?? 0),
    };
  }

  async function fetchCart() {
    const response = await fetch(CART_ENDPOINT, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to load cart for Searchspring tracking');
    }

    return response.json();
  }

  async function syncCartViewNow() {
    const tracker = window.searchspring?.tracker;
    const cartView = tracker?.track?.cart?.view;

    if (typeof cartView !== 'function') return false;

    const cart = await fetchCart();
    const items = Array.isArray(cart?.items)
      ? cart.items.map(toCartItem).filter((item) => item && item.qty > 0)
      : [];

    if (!items.length) return false;

    cartView({ items });
    return true;
  }

  function syncCartView() {
    if (pendingSync) return pendingSync;

    pendingSync = syncCartViewNow()
      .catch((error) => {
        console.error('Searchspring cart tracking failed', error);
        return false;
      })
      .finally(() => {
        pendingSync = null;
      });

    return pendingSync;
  }

  function scheduleCartViewSync() {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    debounceTimer = window.setTimeout(() => {
      debounceTimer = null;
      void syncCartView();
    }, DEBOUNCE_MS);
  }

  window.searchspringTracking = window.searchspringTracking || {};
  window.searchspringTracking.syncCartView = syncCartView;
  window.searchspringTracking.scheduleCartViewSync = scheduleCartViewSync;
})(window);
